import invariant from 'tiny-invariant'

import { Currency } from '../currency'
import { NativeCurrency } from '../NativeCurrency'
import { Token, WNATIVE } from '../token'

/**
 * Base is the main usage of a 'native' currency, i.e. for Base One and all testnets
 */
export class Base extends NativeCurrency {
  protected constructor(chainId: number) {
    super(chainId, 18, 'ETH', 'Ether')
  }

  public get wrapped(): Token {
    const weth = WNATIVE[this.chainId]
    invariant(!!weth, 'WRAPPED')
    return weth
  }

  private static _etherCache: { [chainId: number]: Base } = {}

  public static onChain(chainId: number): Base {
    return this._etherCache[chainId] ?? (this._etherCache[chainId] = new Base(chainId))
  }

  public equals(other: Currency): boolean {
    return other.isNative && other.chainId === this.chainId
  }
}
